import { VazeciProcenatZaradeModalUpdateComponent } from './vazeci-procenat-zarade/vazeci-procenat-zarade-modal-update.component';
import { VazeciProcenatZaradeComponent } from './vazeci-procenat-zarade/vazeci-procenat-zarade.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from '../app.component';
import { ZbirniDnevnikComponent } from './zbirni-dnevnik/zbirni-dnevnik.component';
import { ZbirniDnevnik } from './zbirni-dnevnik/zbirni-dnevnik';
import { ZbirniDnevnikModalUpdateComponent } from './zbirni-dnevnik/zbirni-dnevnik-modal-update.component';
import { FormType, ModalSize, RefreshType, RequestType } from 'yt-ng-framework';
import { YtXchangeComponent } from './yt-xchange.component';
import { WesternUnionModalUpdateComponent } from './western-union/western-union-modal-update.component';
import { WesternUnionComponent } from './western-union/western-union.component';
import { WesternUnion } from './western-union/western-union';
import { PlacanjeRacunaComponent } from './placanje-racuna/placanje-racuna.component';
import { PlacanjeRacunaModalUpdateComponent } from './placanje-racuna/placanje-racuna-modal-update.component';
import { DokumentComponent } from './dokument/dokument.component';
import { Dokument } from './dokument/dokument';
import { DokumentModalUpdateComponent } from './dokument/dokument-modal-update.component';
import { DokumentStavka } from './dokument/dokument-stavka';
import { DokumentStavkaView } from './dokument/dokument-stavka-view';
import { DokumentStavkaModalUpdateComponent } from './dokument/dokument-stavka-modal-update.component';
import { PlacanjeRacuna } from './placanje-racuna/placanje-racuna';
import { DokumentView } from './dokument/dokument-view';
import { NetoOtkupniFondComponent } from './neto-otkupni-fond/neto-otkupni-fond.component';
import { NetoOtkupniFond } from './neto-otkupni-fond/neto-otkupni-fond';
import { ZbirniDnevnikView } from './zbirni-dnevnik/zbirni-dnevnik-view';
import { VazeciProcenatZarade } from './vazeci-procenat-zarade/vazeci-procenat-zarade';
import { LookupsRoutes } from '../lookups/routes';
import { NedeljniNetoOtkupniFondComponent } from './nedeljni-neto-otkupni-fond/nedeljni-neto-otkupni-fond.component';
import { ZaradaPoMenjacniciComponent } from './zarada-po-menjacnici/zarada-po-menjacnici.component';
import { ZaradaPoMenjacnici } from './zarada-po-menjacnici/zarada-po-menjacnici';
import { NedeljniNetoOtkupniFond } from './nedeljni-neto-otkupni-fond/nedeljni-neto-otkupni-fond';
import { StanjePoValutamaComponent } from './stanje-po-valutama/stanje-po-valutama.component';
import { StanjePoValutama } from './stanje-po-valutama/stanje-po-valutama';
import { DefaultFilter } from '../lookups/default-filter/default-filter.component';

let childernRoutes: Routes = [
    {
        path: 'zbirni-dnevnik',
        component: ZbirniDnevnikComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'zbirnidnevnik',
                userRightsModelName: 'xchange-zbirnidnevnik',
                getName: 'getview',
                getParameters: [],
                modelClass: ZbirniDnevnik,
                shortModelClass: ZbirniDnevnikView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'ZBIRNIDNEVNIK.DATUM.SINGULAR', visible: true, type: 'ngbDate', format: 'dd.MM.yyyy' }
                    , { name: 'Ulaz', label: 'ZBIRNIDNEVNIK.Ulaz.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'Izlaz', label: 'ZBIRNIDNEVNIK.Izlaz.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'Razlika', label: 'ZBIRNIDNEVNIK.StanjeBlagajneNaDan.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                ],
                sortBy: 'Datum',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                defaultPropertyName: 'Datum',
                defaultListFilterComponent:DefaultFilter,
                requestType: RequestType.POST
            },
            mainTitle: 'ZbirniDnevnik',
            updateComponent: ZbirniDnevnikModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'ZBIRNIDNEVNIK.PLURAL'
        }
    },
    {
        path: 'western-union',
        component: WesternUnionComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'westernunion',
                userRightsModelName: 'xchange-westernunion',
                getName: 'get',
                getParameters: [],
                modelClass: WesternUnion,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'WESTERNUNION.DATUM.SINGULAR', visible: true, type: 'ngbDate', format: 'dd.MM.yyyy' }
                    , { name: 'UkupnoIsplataRsd', label: 'WESTERNUNION.UKUPNOISPLATARSD.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'UkupnoIsplataEur', label: 'WESTERNUNION.UKUPNOISPLATAEUR.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'UkupnoUplata', label: 'WESTERNUNION.UKUPNOUPLATA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'UkupnoProvizija', label: 'WESTERNUNION.UKUPNOPROVIZIJA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                ],
                sortBy: 'Datum',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                defaultPropertyName: 'Datum',
                defaultListFilterComponent:DefaultFilter,
                requestType: RequestType.POST
            },
            mainTitle: 'WesternUnion',
            updateComponent: WesternUnionModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'WESTERNUNION.SINGULAR'
        }
    },
    {
        path: 'placanje-racuna',
        component: PlacanjeRacunaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'placanjeracuna',
                userRightsModelName: 'xchange-placanjeracuna',
                getName: 'get',
                getParameters: [],
                modelClass: PlacanjeRacuna,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'PLACANJERACUNA.DATUM.SINGULAR', visible: true, type: 'ngbDate', format: 'dd.MM.yyyy' }
                    , { name: 'BrTrans', label: 'PLACANJERACUNA.BRTRANS.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'UkupnoDnevniPromet', label: 'PLACANJERACUNA.UKUPNODNEVNIPROMET.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'UkupnoProvizija', label: 'PLACANJERACUNA.UKUPNOPROVIZIJA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                ],
                sortBy: 'Datum',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                defaultListFilterComponent:DefaultFilter,
                requestType: RequestType.POST
            },
            mainTitle: 'PlacanjeRacuna',
            updateComponent: PlacanjeRacunaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'PLACANJERACUNA.SINGULAR'
        }
    },
    {
        path: 'ulazni-dokumenti',
        component: DokumentComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'xchdokument',
                userRightsModelName: 'xchange-ulaznidokumenti',
                getName: 'get',
                getParameters: [{ Name: 'vrsta', Value: 'U' }],
                modelClass: Dokument,
                shortModelClass: DokumentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'DOKUMENT.DATUM.SINGULAR', visible: true, type: 'ngbDate', format: 'dd.MM.yyyy' }
                    , { name: 'IznosPoKursuTrans', label: 'DOKUMENT.IZNOSPOKURSUTRANS.SINGULAR', visible: true, format: '1.2-2', type: 'number', canHide: true }
                    , { name: 'IznosPoSrednjemKursu', label: 'DOKUMENT.IZNOSPOSREDNJEMKURSU.SINGULAR', visible: true, format: '1.2-2', type: 'number', canHide: true }
                    , { name: 'KursnaRazlika', label: 'DOKUMENT.KURSNARAZLIKA.SINGULAR', visible: true, format: '1.2-2', type: 'number', canHide: true }
                ],
                sortBy: 'Datum',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                defaultPropertyName: 'Datum',
                detailList: [
                    {
                        modelName: 'xchDokumentStavka',
                        getName: 'getByDokumentID',
                        getParameters: [],
                        modelClass: DokumentStavka,
                        shortModelClass: DokumentStavkaView,
                        tableColumns: [
                            { name: 'Valuta', label: 'DOKUMENTSTAVKE.VALUTA.SINGULAR' }
                            , { name: 'PocetnoStanje', label: 'DOKUMENTSTAVKE.POCETNOSTANJE.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'KupovinaOdBanke', label: 'DOKUMENTSTAVKE.KUPOVINAODBANKE.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'UlazSaDeviznogRacuna', label: 'DOKUMENTSTAVKE.ULAZSADEVIZNOGRACUNA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'InterniUlaz', label: 'DOKUMENTSTAVKE.INTERNIULAZ.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'IznosValute', label: 'DOKUMENTSTAVKE.IZNOSVALUTE.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'IznosPoKursuTrans', label: 'DOKUMENTSTAVKE.IZNOSPOKURSUTRANS.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'IznosPoSrednjemKursu', label: 'DOKUMENTSTAVKE.IZNOSPOSREDNJEMKURSU.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'KursnaRazlika', label: 'DOKUMENTSTAVKE.KURSNARAZLIKA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                        ],
                        sortBy: 'Valuta',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'DokumentID',
                        updateComponent: DokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                    }
                ],
                columnClass: 'col-md-5',
                defaultListButtonsOptions: { showDefaultListButtons: true },
                defaultListFilterComponent:DefaultFilter,
                requestType: RequestType.POST
            },
            mainTitle: 'Otkup efektive',
            updateComponent: DokumentModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'DOKUMENT.SINGULAR.OTKUPEFEKTIVE'
        }
    },
    {
        path: 'izlazni-dokumenti',
        component: DokumentComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'xchdokument',
                userRightsModelName: 'xchange-izlaznidokumenti',
                getName: 'get',
                getParameters: [{ Name: 'vrsta', Value: 'I' }],
                modelClass: Dokument,
                shortModelClass: DokumentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'DOKUMENT.DATUM.SINGULAR', visible: true, type: 'ngbDate', format: 'dd.MM.yyyy' }
                    , { name: 'IznosPoKursuTrans', label: 'DOKUMENT.IZNOSPOKURSUTRANS.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'IznosPoSrednjemKursu', label: 'DOKUMENT.IZNOSPOSREDNJEMKURSU.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'KursnaRazlika', label: 'DOKUMENT.KURSNARAZLIKA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                ],
                sortBy: 'Datum',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                defaultPropertyName: 'Datum',
                detailList: [
                    {
                        modelName: 'xchDokumentStavka',
                        getName: 'getByDokumentID',
                        getParameters: [],
                        modelClass: DokumentStavka,
                        shortModelClass: DokumentStavkaView,
                        tableColumns: [
                            { name: 'Valuta', label: 'DOKUMENTSTAVKE.VALUTA.SINGULAR' }
                            , { name: 'IznosValute', label: 'DOKUMENTSTAVKE.IZNOSVALUTE.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'IznosPoKursuTrans', label: 'DOKUMENTSTAVKE.IZNOSPOKURSUTRANS.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'IznosPoSrednjemKursu', label: 'DOKUMENTSTAVKE.IZNOSPOSREDNJEMKURSU.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'Zamena', label: 'DOKUMENT.ZAMENA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'InterniIzlaz', label: 'DOKUMENT.INTERNIIZLAZ.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'IzlazNaDevizniRacun', label: 'DOKUMENT.IZLAZNADEVIZNIRACUN.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'ProdajaBanci', label: 'DOKUMENT.PRODAJABANCI.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'ProdajaBanciObavezi', label: 'DOKUMENT.PRODAJABANCIOBAVEZI.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                            , { name: 'KursnaRazlika', label: 'DOKUMENTSTAVKE.KURSNARAZLIKA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                        ],
                        sortBy: 'Valuta',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'DokumentID',
                        updateComponent: DokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        defaultPropertyName: 'Valuta'
                    }
                ],
                columnClass: 'col-md-5',
                defaultListFilterComponent:DefaultFilter,
                requestType: RequestType.POST
            },
            mainTitle: 'Prodaja efektive',
            updateComponent: DokumentModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'DOKUMENT.SINGULAR.PRODAJAEFEKTIVE'
        }
    },
    // {
    //     path: 'valuta',
    //     component: ValutaComponent,
    //     pathMatch: 'full',
    //     data: {
    //         mainList: {
    //             modelName: 'valuta',
    //             getName: 'get',
    //             getParameters: [],
    //             modelClass: Valuta,
    //             parentProperty:'',
    //             tableColumns: [
    //                 { name: 'Sifra', label: 'VALUTA.SIFRANUMERIC.SINGULAR', visible: true, canHide: false},
    //                 { name: 'Sifra2', label: 'VALUTA.SIFRAALPHA.SINGULAR', visible: true, canHide: false},
    //                 { name: 'Naziv', label: 'VALUTA.NAZIV.SINGULAR', visible: true, canHide: false }                               
    //             ],
    //             sortBy: 'Sifra',
    //             sortReverse: false,
    //             enableEdit: true,
    //             enableDelete: true, 
    //             formType: FormType.Reactive,
    //             // printName: 'printaj'
    //             defaultPropertyName: 'Naziv'
    //         },
    //         mainTitle: 'Valuta',
    //         updateComponent: ValutaModalUpdateComponent,
    //         modalSize: ModalSize.Md,
    //         refreshType: RefreshType.NoReload,
    //         loadOnInit: true,
    //         breadcrumbLabel: 'VALUTA.SINGULAR'
    //     }
    // },
    {
        path: 'neto-otkupni-fond',
        component: NetoOtkupniFondComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'netootkupnifond',
                userRightsModelName: 'xchange-netootkupnifond',
                getName: 'get',
                getParameters: [],
                modelClass: NetoOtkupniFond,
                parentProperty: '',
                tableColumns: [
                    { name: 'OrgJed', label: 'NETOOTKUPNIFOND.ORGJED.SINGULAR' }
                    , { name: 'IznosValuteUlaz', label: 'NETOOTKUPNIFOND.IZNOSVALUTEULAZ.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'IznosValuteIlzlaz', label: 'NETOOTKUPNIFOND.IZNOSVALUTEIZLAZ.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'Razlika', label: 'NETOOTKUPNIFOND.RAZLIKA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                ],
                tableColumnsSums: [
                    {
                        columns: [
                            'IznosValuteUlaz',
                            'IznosValuteIlzlaz',
                            'Razlika'
                        ]
                    }
                ],
                sortBy: 'ID',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
            },
            mainTitle: 'Neto otkupni fond',
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'NETOOTKUPNIFOND.SINGULAR'
        }
    },
    {
        path: 'vazeciprocenatzarade',
        component: VazeciProcenatZaradeComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'vazeciprocenatzarade',
                userRightsModelName: 'xchange-vazeciprocenatzarade',
                getName: 'get',
                getParameters: [],
                modelClass: VazeciProcenatZarade,
                parentProperty: '',
                tableColumns: [
                    { name: 'DatumOd', label: 'VAZECIPROCENATZARADE.DATUM.SINGULAR', visible: true, canHide: false, type: 'ngbDate' },
                    { name: 'ProcenatPlatniPromet', label: 'VAZECIPROCENATZARADE.PROCENATPLATNIPROMET.SINGULAR', visible: true, canHide: false },
                    { name: 'ProcenatWesternUnion', label: 'VAZECIPROCENATZARADE.PROCENATWESTERNUNION.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'DatumOd',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                defaultPropertyName: 'DatumOd'
            },
            mainTitle: 'VazeciProcenatZarade',
            updateComponent: VazeciProcenatZaradeModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VAZECIPROCENATZARADE.SINGULAR'
        }
    },
    {
        path: 'nedeljni-neto-otkupni-fond',
        component: NedeljniNetoOtkupniFondComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'nedeljninetootkupnifond',
                userRightsModelName: 'xchange-nedeljninetootkupnifond',
                getName: 'get',
                getParameters: [],
                modelClass: NedeljniNetoOtkupniFond,
                parentProperty: '',
                tableColumns: [
                    { name: 'OrgJed', label: 'NEDELJNINETOOTKUPNIFOND.ORGJED.SINGULAR', width: 'auto' }
                    , { name: 'IznosUlaz1', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEULAZ1.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosIzlaz1', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEIZLAZ1.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosUlaz2', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEULAZ2.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosIzlaz2', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEIZLAZ2.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosUlaz3', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEULAZ3.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosIzlaz3', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEIZLAZ3.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosUlaz4', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEULAZ4.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosIzlaz4', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEIZLAZ4.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosUlaz5', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEULAZ5.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosIzlaz5', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEIZLAZ5.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosUlaz6', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEULAZ6.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosIzlaz6', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEIZLAZ6.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosUlaz7', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEULAZ7.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'IznosIzlaz7', label: 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEIZLAZ7.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'UkupnoUlaz', label: 'NEDELJNINETOOTKUPNIFOND.UKUPNOVALUTEULAZ.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                    , { name: 'UkupnoIzlaz', label: 'NEDELJNINETOOTKUPNIFOND.UKUPNOVALUTEIZLAZ.SINGULAR', visible: true, format: '1.2-2', type: 'number', width: '5.5%' }
                ],
                tableColumnsSums: [
                    {
                        columns: [
                            'IznosUlaz1',
                            'IznosIzlaz1',
                            'IznosUlaz2',
                            'IznosIzlaz2',
                            'IznosUlaz3',
                            'IznosIzlaz3',
                            'IznosUlaz4',
                            'IznosIzlaz4',
                            'IznosUlaz5',
                            'IznosIzlaz5',
                            'IznosUlaz6',
                            'IznosIzlaz6',
                            'IznosUlaz7',
                            'IznosIzlaz7',
                            'UkupnoUlaz',
                            'UkupnoIzlaz'
                        ]
                    }
                ],
                sortBy: 'ID',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive
            },
            mainTitle: 'Nedeljni neto otkupni fond',
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'NEDELJNINETOOTKUPNIFOND.SINGULAR'
        }
    }
    , {
        path: 'zarada-po-menjacnici',
        component: ZaradaPoMenjacniciComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'zaradapomenjacnici',
                userRightsModelName: 'xchange-zaradapomenjacnici',
                getName: 'GetByOrgJedId',
                getParameters: [],
                modelClass: ZaradaPoMenjacnici,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'ZARADAPOMENJACNICI.DATUM.SINGULAR', visible: true, type: 'ngbDate', format: 'dd.MM.yyyy' }
                    , { name: 'Komitent', label: 'ZARADAPOMENJACNICI.KOMITENTNAZIV.SINGULAR', visible: true }
                    , { name: 'VrstaTroska', label: 'ZARADAPOMENJACNICI.VRSTATROSKANAZIV.SINGULAR', visible: true }
                    , { name: 'IznosZarada', label: 'ZARADAPOMENJACNICI.IZNOSZARADA.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'IznosTrosak', label: 'ZARADAPOMENJACNICI.IZNOSTROSAK.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'Saldo', label: 'ZARADAPOMENJACNICI.SALDO.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                ],
                sortBy: 'ID',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
            },
            mainTitle: 'Zarada po menjačnici',
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'ZARADAPOMENJACNICI.SINGULAR'
        }
    }
    , {
        path: 'stanje-po-valutama',
        component: StanjePoValutamaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'stanjepovalutama',
                userRightsModelName: 'xchange-stanjepovalutama',
                getName: 'Get',
                getParameters: [],
                modelClass: StanjePoValutama,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'STANJEPOVALUTAMA.DATUM.SINGULAR', visible: true, type: 'ngbDate', format: 'dd.MM.yyyy' }
                    , { name: 'RSD', label: 'STANJEPOVALUTAMA.RSD.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'EUR', label: 'STANJEPOVALUTAMA.EUR.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'USD', label: 'STANJEPOVALUTAMA.USD.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'GBP', label: 'STANJEPOVALUTAMA.GBP.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'CAD', label: 'STANJEPOVALUTAMA.CAD.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'CHF', label: 'STANJEPOVALUTAMA.CHF.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'AUD', label: 'STANJEPOVALUTAMA.AUD.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'BAM', label: 'STANJEPOVALUTAMA.BAM.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'SEK', label: 'STANJEPOVALUTAMA.SEK.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'NOK', label: 'STANJEPOVALUTAMA.NOK.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                    , { name: 'Ukupno', label: 'Ukupno', visible: true, format: '1.2-2', type: 'number' }
                ],
                sortBy: 'ID',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
            },
            mainTitle: 'Stanje po valutama',
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'STANJEPOVALUTAMA.SINGULAR'
        }
    }
];

childernRoutes = childernRoutes.concat(LookupsRoutes);

const routes: Routes = [
    {
        path: '',
        component: YtXchangeComponent,
        children: childernRoutes
    }
]


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class YtXChangeRoutingModule { }
